import axios from "@/plugins/axios";

import memo from "./memo";
import micepecRecords from "./micepec-records";

let url = (data) => "/api/v1/company/recruitments/${_recruitment}/applications".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
    putIsCertified(data) {
        return axios.put(`${url(data)}/${data?._id}/is-certified`, data).then((result) => result.data);
    },

    memo,
    micepecRecords,
};
